import React, { useState }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ConfirmationModal from '../components/ConfirmationModal';
import green from '@material-ui/core/colors/green';
import { LoanService } from '../services';
import { useError } from '../contexts/ErrorContext';

const styles = makeStyles(() => ({
    submitButton: {
        marginLeft: '10px',
        marginTop: '25px'
    },
    confirmButton: {
        backgroundColor: green[400],
        float: 'right',
        marginTop:'16px',
        marginRight:'4px'

    },
    inputAmount: {
        float: 'right',
        marginTop: '8px',
        marginRight:'4px',
        marginBottom: '4px'
    }
}));

const PullDelinquenciesComment = (props) => {
    const { showError } = useError();
    const [showConfirmConfirmationBox, setShowConfirmConfirmationBox] = useState(false);
    const toggleConfirmConfirmation = () => setShowConfirmConfirmationBox(!showConfirmConfirmationBox);

    const handleConfirmPullDelinquenciesCommentButtonClick = async (event) => {
        toggleConfirmConfirmation();
    }
    
    const handleConfirmPullDelinquenciesCommentButton = async (event) => {
        LoanService.pullDelinquenciesComment().catch(showError);
        toggleConfirmConfirmation();
    }

    const classes = styles();
    return(
        <div>
            <ConfirmationModal title="Confirm" message="Are you sure you want to pull today's delinquency comment?" onConfirm={handleConfirmPullDelinquenciesCommentButton} onCancel={toggleConfirmConfirmation} showConfirmationBox={showConfirmConfirmationBox}/>

            <Button variant="contained"
            className={classes.confirmButton}
            onClick={handleConfirmPullDelinquenciesCommentButtonClick}
            >submit
            </Button>

        </div>
    )
}

export default PullDelinquenciesComment;